import React from "react";
import ContentLoader from "react-content-loader";
import { Row, Col, Card } from "react-bootstrap";

const CheckoutLoader = (props) => (
    <Row className="mb-5">
        {/* Left Side: Event Info Skeleton Card */}
        <Col md={5} sm={12} lg={5} xl={5}>
            <Card className="event-sidebar mm-2">
                <Card.Body>
                    <ContentLoader
                        speed={2}
                        width="100%"
                        height={500}
                        viewBox="0 0 450 500"
                        backgroundColor="#f3f3f3"
                        foregroundColor="#ecebeb"
                        {...props}
                    >
                        {/* Event Image */}
                        <rect x="0" y="0" rx="8" ry="8" width="450" height="220" />
                        
                        {/* Event Title */}
                        <rect x="0" y="240" rx="4" ry="4" width="320" height="24" />
                        
                        {/* Date */}
                        <circle cx="12" cy="290" r="10" />
                        <rect x="35" y="282" rx="4" ry="4" width="200" height="16" />
                        
                        {/* Time */}
                        <circle cx="12" cy="325" r="10" />
                        <rect x="35" y="317" rx="4" ry="4" width="160" height="16" />
                        
                        {/* Category */}
                        <circle cx="12" cy="360" r="10" />
                        <rect x="35" y="352" rx="4" ry="4" width="140" height="16" />
                        
                        {/* Venue */}
                        <circle cx="12" cy="395" r="10" />
                        <rect x="35" y="387" rx="4" ry="4" width="260" height="16" />
                        
                        {/* Divider */}
                        <rect x="0" y="430" rx="2" ry="2" width="450" height="2" />
                        
                        {/* Price */}
                        <rect x="0" y="450" rx="4" ry="4" width="100" height="24" />
                        <rect x="320" y="450" rx="4" ry="4" width="120" height="18" />
                    </ContentLoader>
                </Card.Body>
            </Card>
        </Col>

        {/* Right Side: Booking Form Skeleton Card */}
        <Col md={7} sm={12} lg={7} xl={7}>
            <Card className="event-sidebar mm-2">
                <Card.Header>
                    <ContentLoader
                        speed={2}
                        width="100%"
                        height={25}
                        viewBox="0 0 300 25"
                        backgroundColor="#f3f3f3"
                        foregroundColor="#ecebeb"
                        {...props}
                    >
                        <rect x="0" y="2" rx="4" ry="4" width="160" height="20" />
                    </ContentLoader>
                </Card.Header>
                <Card.Body>
                    <ContentLoader
                        speed={2}
                        width="100%"
                        height={420}
                        viewBox="0 0 600 420"
                        backgroundColor="#f3f3f3"
                        foregroundColor="#ecebeb"
                        {...props}
                    >
                        {/* Username Label & Input */}
                        <rect x="0" y="10" rx="4" ry="4" width="110" height="15" />
                        <rect x="0" y="35" rx="6" ry="6" width="600" height="42" />

                        {/* Email Label & Input */}
                        <rect x="0" y="95" rx="4" ry="4" width="90" height="15" />
                        <rect x="0" y="120" rx="6" ry="6" width="600" height="42" />

                        {/* Number of Tickets Label & Dropdown */}
                        <rect x="0" y="180" rx="4" ry="4" width="150" height="15" />
                        <rect x="0" y="205" rx="6" ry="6" width="600" height="42" />

                        {/* Total Amount Row */}
                        <rect x="0" y="275" rx="4" ry="4" width="120" height="18" />
                        <rect x="500" y="270" rx="4" ry="4" width="100" height="26" />

                        {/* Divider */}
                        <rect x="0" y="320" rx="2" ry="2" width="600" height="2" />

                        {/* Checkout Button */}
                        <rect x="420" y="350" rx="6" ry="6" width="180" height="45" />
                    </ContentLoader>
                </Card.Body>
            </Card>
        </Col>
    </Row>
);

export default CheckoutLoader;
